import { Subject } from 'rxjs';

const subject = new Subject();

export const notificationDetailService = {
    emitReload: (val, group) => subject.next({val, group}),
    reload: () => subject.asObservable()
};